// extracted by mini-css-extract-plugin
export default {"container":"owned_container__dPPSB","wrapper":"owned_wrapper__tCZN+","cardWrapper":"owned_cardWrapper__IkrDc"};